(() => {
  if (customElements.get('eo-ritual-finder')) return;

  class EORitualFinder extends HTMLElement {
    connectedCallback() {
      this.onClick = this.handleClick.bind(this);
      this.onKeydown = (event) => {
        const choice = event.target.closest('[data-ritual-value]');
        if (choice && event.key === ' ') {
          event.preventDefault();
          choice.click();
        }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.collection = document.querySelector('.collection-essential-oils, .collection-essential-oil-blends');
      this.sidebar = this.collection?.querySelector('[data-collection-sidebar]');
      if (this.sidebar) {
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.sidebar, { childList: true, subtree: true });
        this.sync();
      }
    }

    sync() {
      const inputs = Array.from(this.sidebar.querySelectorAll('input[name="filter.p.m.custom.eo_ritual_mood"]'));
      this.querySelectorAll('[data-ritual-value]').forEach((choice) => {
        const value = choice.dataset.ritualValue;
        const input = inputs.find((item) => item.value === value);
        const current = new URL(window.location.href);
        const selected = current.searchParams.getAll('filter.p.m.custom.eo_ritual_mood').flatMap((item) => item.split(','));
        const active = selected.includes(value);
        const count = Number(input?.dataset.eoCount || 0);
        const disabled = !active && (!input || input.disabled);
        choice.classList.toggle('is-selected', active);
        choice.setAttribute('aria-pressed', String(active));
        choice.setAttribute('aria-disabled', String(disabled));
        choice.tabIndex = disabled ? -1 : 0;
        choice.querySelector('[data-ritual-count]').textContent = `${count} ${count === 1 ? 'oil' : 'oils'}`;
        current.searchParams.delete('page');
        current.searchParams.delete('filter.p.m.custom.eo_ritual_mood');
        const next = active ? selected.filter((item) => item !== value) : [...selected, value];
        [...new Set(next)].forEach((item) => current.searchParams.append('filter.p.m.custom.eo_ritual_mood', item));
        if (disabled) choice.removeAttribute('href');
        else choice.setAttribute('href', current.pathname + (current.search ? current.search : ''));
      });
    }

    handleClick(event) {
      const choice = event.target.closest('[data-ritual-value]');
      if (!choice || !this.contains(choice)) return;
      if (choice.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const controller = this.collection?.querySelector('collection-filters-form');
      if (typeof controller?.submitForm !== 'function') return;
      event.preventDefault();
      // Use the theme's own URL-based filtering and product refresh.
      controller.submitForm(event, choice.getAttribute('href'));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
    }
  }

  customElements.define('eo-ritual-finder', EORitualFinder);
})();
